export default defineNuxtRouteMiddleware((to) => {
  if (!useIsFeatureFlagEnabled('mergedLotteryPage')) return

  const localePath = useLocalePath()
  const lotteryId = String(to.params.lotteryId).toLowerCase()

  return navigateTo(localePath({ path: `/${lotteryId}`, query: to.query, hash: to.hash }), {
    replace: true,
  })
})
